import React, { useContext } from "react";
import { LazyLoadImage } from "react-lazy-load-image-component";
import GalleryContext from "../../context/GalleryContext";
import { OPEN_LIGHTBOX } from "../../context/types/GalleryTypes";

const GalleryImage = ({ glr }) => {
  //const { dispatch } = useContext(GalleryContext);

  const { dispatch } = useContext(GalleryContext);

  const openLightBox = (imageObject) => {
    //console.log(dispatch);
    dispatch({ type: OPEN_LIGHTBOX, payload: imageObject });
    //console.log(payload);
  };
  return (
    <div className="col-3">
      <div className="gallery__image animation">
        <LazyLoadImage
          src={glr.image}
          alt={glr.image}
          onClick={() => openLightBox(glr)}
        />
      </div>
    </div>
  );
};

export default GalleryImage;
